import styled from 'styled-components';

import CloseButton from 'components/close-button';
import { primitive } from 'styles/constants/primitives';

export const ModalCloseButton = styled(CloseButton)`
  left: calc(1.25rem + env(safe-area-inset-left));
  position: fixed;
  top: calc(1rem + env(safe-area-inset-top));
  z-index: ${Styles.zIndex.below};
  color: ${p => p.theme.token('text-button-primary')};
  background: transparent;
`;

export const Background = styled.div`
  position: relative;
  background: linear-gradient(
    ${({ theme }) => theme.token('background-active')} 0 62px,
    ${({ theme }) => theme.token('background-pattern')} 62px 100%
  );
`;

export const AllModalContent = styled.div`
  background-color: ${p => p.theme.token('background-pattern')};
  width: 100%;
  height: 100%;
`;

export const RewardCategoriesContainer = styled.div`
  padding: ${primitive.$spacing11} 0 ${primitive.$spacing10};
`;

export const PositionedLogoContainer = styled.div`
  left: 50%;
  top: ${primitive.$spacing7};
  padding-top: env(safe-area-inset-top);
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: ${Styles.zIndex.max - 300};
`;
